import { Col, DatePicker, Row, Tabs, message } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Select } from "antd";
import {
  addMeeting,
  fetchAllMeeting,
  fetchOneMeeting,
  updateMeeting,
} from "redux/features/sidang";
import { MyEditor } from "../../../components/Editor";
import ImageUploader from "components/shared-components/ImageUploader";
import moment from "moment";

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "Wajib Diisi!",
  },
];

export const ADD_UNDANGAN = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();

  const [idBody, setIdBody] = useState("");
  const [enBody, setEnBody] = useState("");
  const [subcategories, setSubcategories] = useState();
  const [tags, setTags] = useState();
  const [imgUrl, setImgUrl] = useState("");
  const [data, setData] = useState([]);

  const onFinish = (values) => {
    sendScopeToAPI(values.meeting_id, values.scope);
  };

  const sendScopeToAPI = async (meetingId, scopeType) => {
    try {
      const res = await fetch(
        `https://api.banyuasinkab.info/api/v1/meeting/${meetingId}/scope`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ type: scopeType }),
        }
      );

      if (!res.ok) throw new Error("Gagal kirim data scope");

      const result = await res.json();
      console.log("Scope dikirim:", result);
      message.success("Undangan berhasil dibuat");
    } catch (error) {
      console.error(error);
      message.error("Gagal kirim scope");
    }
  };

  const updateData = async (values) => {
    try {
      await dispatch(
        updateMeeting({
          ...values,
          id: location?.state?.id,
          date: moment(values.date).format("YYYY-MM-DDTHH:mm"),
        })
      ).unwrap();
      history.push("/app/sidang");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getData = async () => {
    try {
      const res = await dispatch(fetchAllMeeting()).unwrap();
      setData(res.data);
      console.log("r:", res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneMeeting(id)).unwrap();
      form.setFieldsValue({
        ...data.data,
        category: data.data.category_id,
        // content_tags: data.data.content_tags.map((item) => item.tag_id),
        date: moment(data.data.date),
      });
      //   setEnBody(data?.data.body_en);
      //   setIdBody(data?.data.body);
      //   setImgUrl(data.data.thumbnail);
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageUpload = (info) => {
    if (info.file.status === "uploading") {
      // setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      setImgUrl(info.file.response.secure_url);
    }
  };

  useEffect(() => {
    if (location?.state?.id) {
      getDataById(location?.state?.id);
    }
    getData();
  }, []);

  const { Option } = Select;

  const meetingOptions = [
    {
      id: "1",
      name: "Sidang Anggaran 2025",
      tanggal: "2024-05-10",
      waktu: "10:00",
      lokasi: "Ruang Sidang Utama",
    },
    {
      id: "2",
      name: "Rapat Paripurna Mei",
      tanggal: "2024-05-15",
      waktu: "13:00",
      lokasi: "Ruang Paripurna",
    },
    {
      id: "3",
      name: "Pembahasan RUU Pendidikan",
      tanggal: "2024-05-20",
      waktu: "09:00",
      lokasi: "Komisi A",
    },
  ];

  const [selectedMeeting, setSelectedMeeting] = useState(null);

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update Undangan</h2>
          <p>Tambah undangan dan kegiatan lainnya</p>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Nama Meeting"
                name="meeting_id"
                rules={[{ required: true, message: "Pilih nama meeting" }]}
              >
                <Select
                  placeholder="Pilih Meeting"
                  onChange={(value) => {
                    const meeting = data.find((m) => m.id === value);
                    setSelectedMeeting(meeting);
                  }}
                >
                  {data.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {selectedMeeting && (
                <div
                  style={{
                    marginBottom: "16px",
                    padding: "12px",
                    background: "#fafafa",
                    border: "1px solid #eaeaea",
                    borderRadius: "4px",
                  }}
                >
                  <p>
                    <strong>Tanggal:</strong>{" "}
                    {moment(selectedMeeting.date).format("dddd, DD MMMM YYYY")}
                  </p>
                  <p>
                    <strong>Waktu:</strong>{" "}
                    {moment(selectedMeeting.date).format("HH:mm")}
                  </p>
                  <p>
                    <strong>Lokasi:</strong> {selectedMeeting.location}
                  </p>
                </div>
              )}

              <Form.Item
                label="Kirim ke"
                name="scope"
                rules={[{ required: true, message: "Pilih penerima undangan" }]}
              >
                <Select placeholder="Pilih penerima">
                  <Option value="all">Semua</Option>
                  <Option value="dewan">Staff</Option>
                  <Option value="commision">Dewan</Option>
                  <Option value="department">Dewan</Option>
                </Select>
              </Form.Item>

              {/* <Form.Item label="Lokasi Sidang" name="location">
                <Input />
              </Form.Item> */}

              {/* <Form.Item
                label="Thumbnail"
                name="thumbnail"
                rules={[
                  {
                    required: true,
                    message: "Please upload your Thumbnail",
                  },
                ]}
              >
                <ImageUploader imageUrl={imgUrl} onChange={handleImageUpload} />
              </Form.Item> */}

              {/* <Form.Item label="File URL" name="file">
                <Input />
              </Form.Item> */}

              {/* <Form.Item label="Jadwal Sidang" name="date" rules={rules}>
                <DatePicker showTime format="YYYY-MM-DDTHH:mm" />
              </Form.Item> */}

              {/* <Form.Item>
                <MyEditor
                  data={idBody}
                  setState={setIdBody}
                  defaultValue="Indonesian Content"
                />
              </Form.Item> */}

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Buat Undangan
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ADD_UNDANGAN;
